export enum ScrollElearningContentSlideType {
  Video = 'video',
  AnimWithText = 'animWithText',
  ImageWithText = 'imageWithText',
  ChooseAnswer = 'chooseAnswer',
  TextBox = 'textBox',
  CenteredContentSlide = 'centeredContentSlide',
  ChoiceQuiz = 'choiceQuiz',
  ProgressiveQuiz = 'progressiveQuiz',
  InsuranceTable = 'insuranceTable',
  InsuranceCalculator = 'insuranceCalculator',
  SelectVideo = 'selectVideo',
  AdditionalProfitsCalculator = 'additionalProfitsCalculator',
  InsuranceValueCalculator = 'insuranceValueCalculator',
  AnimationsWithStatementChoice = 'animationsWithStatementChoice',
  MatchToCategory = 'matchToCategory',
  TableWthText = 'tableWithText',
  DragAndDrop = 'dragAndDrop',
  InteractionSlideCustomAction = 'interactionSlideCustomAction',
  BenefitCalculator = 'benefitCalculator'
}
